import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  OpinionOfConformityPropertyDataSectionComponent
} from './sections/opinion-of-conformity-property-data-section/opinion-of-conformity-property-data-section.component';
import {
  InvestmentCharacteristicsSectionComponent
} from './sections/investment-characteristics-section/investment-characteristics-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Dane nieruchomości',
  'Charakterystyka inwestycji',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../dane-nieruchomosci',
  cancelUrl: '../wnioskodawca'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../charakterystyka-inwestycji',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const opinionOfConformityRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: OpinionOfConformityPropertyDataSectionComponent,
    path: ':appId/dane-nieruchomosci'
  },
  {
    component: InvestmentCharacteristicsSectionComponent,
    path: ':appId/charakterystyka-inwestycji'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
